<div class="d-flex justify-content-center {{ class }}">
  <div class="spinner-border" *ngIf="show"></div>
</div>
